import { useTranslation } from 'react-i18next';
import type { BasketTotalSummary } from 'autogen/swagger/all';
import { TotalPrice as TotalPriceTrans, VATOfTotal, WithVAT } from 'autogen/translation-keys/trans-website-basket';
import { Price } from 'components/generic/productPrice';
import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
type TotalPrice = Record<string, any> & { model: PartialBy<BasketTotalSummary, 'totalVat'> };

export default function TotalPrice({ model, ...restProps }: TotalPrice) {
    const { totalVat, total } = model;
    const { t } = useTranslation();

    return (
        <Layout.Flex.Row justifyContent="space-between" alignItems="center" {...restProps}>
            <Typography.Body as="span">
                <b>{t(TotalPriceTrans)}</b> {`(${t(WithVAT)})`} <br />
                {totalVat && `(${t(VATOfTotal)} ${totalVat})`}
            </Typography.Body>
            <Price price={total} />
        </Layout.Flex.Row>
    );
}
